import { IContainer, injectContainer } from '../../interface/container';

export interface IResponseSerialized {
    headers: any;
    status: number;
    statusText: string;
    body: string;
}

export interface IResponseSerializer {
    serialize: (request: Response) => Promise<IResponseSerialized>;
    parse: (request: IResponseSerialized) => Response;
}

const TYPES = {
    IResponseSerializer: Symbol.for('IResponseSerializer'),
};

export function injectResponseSerializer(
    container: IContainer = injectContainer(),
): IResponseSerializer {
    return container.get<IResponseSerializer>(TYPES.IResponseSerializer);
}

export function bindResponseSerializer(
    val: IResponseSerializer,
    container: IContainer = injectContainer(),
) {
    return container.bind<IResponseSerializer>(TYPES.IResponseSerializer, val);
}

export function unbindResponseSerializer(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IResponseSerializer);
}
